@import 'apps/webcomponents/src/assets/common.scss';

.exclusion-lists {
  display: flex;
  flex-direction: column;
  height: 100%;

  &--header {
    line-height: 0;
    padding: var(--spacer) calc(2 * var(--spacer));
    margin-bottom: var(--spacer);
  }

  &--content {
    flex: 1 1 0%;
    overflow: auto;
  }

  .title {
    margin-bottom: calc(3 * var(--spacer));
  }

  .exclusion-list {
    border-top: 1px solid var(--chart-101-pressed-dividers);
    margin-bottom: var(--spacer);
    &--title {
      padding: var(--spacer) calc(2 * var(--spacer));
      min-height: calc(4 * var(--spacer));
      color: var(--chart-302-icon-buttons-titles);
    }
  }

  gz-list-item {
    padding-left: calc(2 * var(--spacer)) !important;
  }
}
